import { io } from "socket.io-client";
import { App, reactive, ref } from "vue";
import { SOCKET_URL } from "@/configs/app";
import { IUnknownObject } from "@/@types/common";
import { log } from "@/utils/log";
import { api } from '@/api/index';

export const socket: any = ref(null);

export async function socketEmit(emit: string, data: IUnknownObject = {}) {
    log('socket:emit', emit, data);
    return new Promise((resolve, reject) => {
        if (socket.value == null) {
            reject('No socket connection.');
        } else {
            socket.value.emit(emit, data, (response: any) => {
                if (response.ok) {
                    resolve(response.data);
                } else {
                    reject(response.error);
                }
            });
        }
    });
}

export async function socketOn(emit: string, callback = (r: any) => {}) {
    log('socket:on', emit);
    socket.value.on(emit, callback);
}

export function socketOff(emit: string) {
    log('socket:off', emit);
    socket.value.off(emit);
}

export async function socketOn2(emit: string) {
    log('socket:on', emit);
    return new Promise((resolve, reject) => {
        if (socket.value === null) {
            reject('No socket connection.');
        } else {
            socket.value.on(emit, (response: any) => {
                if (response.ok) {
                    resolve(response.data);
                } else {
                    reject(response.error);
                }
            });
        }
    });
}

export const Socket = {
    install(Vue: App) {
        socket.value = io(SOCKET_URL, {
            auth: {
                token: localStorage.getItem('token'),
            },
            transports: ['websocket'],
            path: '/socket.io',
            withCredentials: false,
            reconnection: true,
            reconnectionAttempts: Infinity,
            reconnectionDelay: 1000,
            reconnectionDelayMax: 5000,
        });

        socket.value.on('connect', () => {
            log('socket:connection', 'Сокетное соединение установлено');
            try {
                // Экспортируем sid для быстрой проверки в консоли
                (window as any).socketId = socket.value?.id;
                console.log('socket connected, id=', (window as any).socketId);
            } catch (e) {}
            // Пробрасываем socket.id в axios заголовки для адресной доставки
            try {
                if (api && api.defaults && socket.value?.id) {
                    api.defaults.headers['X-SOCKET-ID'] = socket.value.id;
                }
            } catch (e) {}
        });

        socket.value.on("connect_error", (err: any) => {
            log('danger', 'Ошибка подключения к сокету');
            console.error('socket connect_error', err?.message || err);
            setTimeout(() => socket.value.connect(), 1000);
        });
    },
};
